import { createStyles } from "@mantine/emotion";

export const useStylesUserContent = createStyles((theme) => {
  return {
    userContent: {
      fontSize: theme.spacing.userContent.fontSize,
      a: {
        textDecoration: "underline",
        "&:hover": {
          textDecoration: "none",
        },
      },
      "ul, ol": {
        paddingLeft: theme.spacing.userContent.list.paddingLeft,
      },
    },
    blockFlex: {
      gap: theme.spacing.userContent.blockFlex.gap,
      ".block-flex-left": {
        width: theme.spacing.userContent.blockFlex.left.width,
        maxWidth: "100%",
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          width: "100%",
        },
      },
      ".block-flex-right": {
        width: theme.spacing.userContent.blockFlex.right.width,
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          marginTop: theme.spacing.userContent.blockFlex.right.marginTop,
        },
      },
    },
  };
});
